export default __webpack_public_path__ + "static/media/idilioVistaniaConcept.8630b428.mp3";